<style lang="scss">
  @import "@/assets/scss/vuexy/components/login.scss";
</style>
<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="image-container-background">
          <vs-alert v-if="this.expired" :active="inputValid" color="danger" icon-pack="feather" icon="icon-info">
            <span>{{$t('Messages.Sesion')}}</span>
          </vs-alert>
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2 login-image-container">
              <img :src="getImg()" alt="login" class="mx-auto login-image">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg ">
              <div class="float-right">
                <i18n textColor="text-primary" :isShow="true"/>
              </div>
              <div class="p-8 login-tabs-container">
                <div class="spore-logo-container">
                  <img src="@/assets/images/logo/logo.png" alt="login" class="spore-login-logo">
                </div>
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">{{$t("WelcomeMessage")}}</h4>
                  <p>{{$t("InputDataMessage")}}</p>
                </div>

                <div>
                  <vs-input
                  name="email"
                  icon-no-border
                  icon="icon icon-user"
                  icon-pack="feather"
                  :label-placeholder="$t('Email')"
                  v-model="email"
                  class="w-full" v-on:keyup.13="getLogin"/>

                  <vs-input
                  type="password"
                  name="password"
                  icon-no-border
                  icon="icon icon-lock"
                  icon-pack="feather"
                  :label-placeholder="$t('Password')"
                  v-model="password"
                  class="w-full mt-6" v-on:keyup.13="getLogin"/>
                  <span class="text-danger text-sm" v-show="error">{{$t("Messages.MissingParams")}}</span>
                  <div class="flex flex-wrap justify-between my-5" >
                    <div class="float-right">
                      <router-link class="forgotten-password-link" to="/forgot-password">{{$t("ForgotPassword")}}</router-link>
                    </div>
                  </div>
                  <vs-button class="float-right login-button" style="margin-bottom: 50px;"  v-on:click="getLogin()">{{$t("Enter")}}</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
import { request } from '@/request.js'
import { setToken, setSessionStorage, parseJwt } from '@/sessionStorage.js'
import i18n from '@/layouts/components/vertical-nav-menu/I18n.vue'
import { app } from './../../main'

export default {
  components: {
    i18n
  },
  props: {
    urlLogin: String,
    redirectPath: String,
    img: String
  },
  data () {
    return {
      email: '',
      password: '',
      error: false,
      expired: false
    }
  },
  methods: {
    async getLogin () {
      if (this.email && this.password) {
        this.$vs.loading()
        this.error = false

        const params = {
          url: this.urlLogin,
          method: 'POST',
          validate: false,
          params: {
            email: this.email,
            password: btoa(this.password)
          }
        }
        await request(params).then(response => {
          setSessionStorage('email', btoa(this.email))
          setSessionStorage('pass', btoa(this.password))
          setToken(response.data.data)
          const jwt = parseJwt(response.data.data)
          const userDefaults = {
            uid: jwt.u.user_uuid,
            displayName: jwt.u.name || 'Usuario General',
            avatar: jwt.u.avatar || '',
            status: 'online',
            userRole: jwt.u.type || 'MA',
            token: response.data.data
          }
          this.$store.commit('UPDATE_USER_INFO', userDefaults)
          this.$router.push(this.redirectPath)
        }).finally(() => {
          this.$vs.loading.close()
          this.password = ''
        })
      } else this.error = true
    },
    getImg () {
      const images = require.context('@/assets/images/pages/login/', false, /\.png$/)
      if (app.$route.path === '/login') {
        this.expired = true
      }
      return images(`./${this.img}`)
    }
  }

}
</script>
